<script>
    import { navigate } from '../router.js';
    export let page;
    export let onSkin;
    export let onRoutine;
    $: tabs = [
        { label: 'Home', icon: 'M3 10 12 3l9 7v11h-6v-7H9v7H3Z', active: page === 'home', action: () => navigate('home') },
        { label: 'My Skin', icon: 'M12 3C9 7 5 11 5 15a7 7 0 0 0 14 0c0-4-4-8-7-12Z', active: ['face-analysis-result', 'skin-questions'].includes(page), action: onSkin },
        { label: 'Products', icon: 'M8 3h8v4H8ZM7 7h10l2 14H5Z', active: page === 'scanner', action: () => navigate('scanner') },
        { label: 'Routine', icon: 'm4 7 2 2 4-4M13 7h7M4 16l2 2 4-4M13 16h7', active: ['routine', 'recommendations', 'routine-import', 'next-step'].includes(page), action: onRoutine },
        { label: 'Progress', icon: 'M4 3v18h17M7 15l4-5 4 2 6-7', active: page === 'progress', action: () => navigate('progress') }
    ];
</script>
<nav aria-label="App navigation">
    {#each tabs as tab}
        <button class:active={tab.active} aria-current={tab.active ? 'page' : undefined} on:click={tab.action}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d={tab.icon}/></svg>
            <span>{tab.label}</span>
        </button>
    {/each}
</nav>
<style>
    nav { position: fixed; bottom: 0; left: 0; right: 0; z-index: 1000; display: flex; background: #101310; border-top: 1px solid #333b32; padding: 8px 8px calc(8px + env(safe-area-inset-bottom, 0px)); }
    button { flex: 1; min-width: 0; min-height: 52px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 5px; background: transparent; border: 0; color: #b5bdb2; font: inherit; font-size: 10px; cursor: pointer; }
    button.active { color: #c9e5ad; }
    button:focus-visible { outline: 2px solid #c9e5ad; outline-offset: -2px; border-radius: 10px; }
    svg { width: 23px; height: 23px; }
</style>
